// oktaClient.js
import { OktaAuth } from '@okta/okta-auth-js'
import {
  OKTA_INTERNAL_CONFIG,
} from './ui/utilities/oktaConstant'

console.log('fixing issue of the pipeline');

const internalConfig = OKTA_INTERNAL_CONFIG

const oktaAuthObject = new OktaAuth({
  ...internalConfig,
  // optional but stabilizes storage across reloads
  tokenManager: { storage: 'sessionStorage' },
})
export { internalConfig, oktaAuthObject }
